import { render, staticRenderFns } from "./fullIframe.vue?vue&type=template&id=95dc6e4c"
import script from "./fullIframe.vue?vue&type=script&lang=js"
export * from "./fullIframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports